import { COMMON } from "constants/brm";
import { Select } from "./styles/tables.styles";

const SelectCiaLevelColumnFilter = ({ column: { setFilter } }: any) => (
  <Select
    id="custom-select"
    onChange={(e) => {
      setFilter(e.target.value || undefined);
    }}
  >
    <option value="">All</option>
    <option value={COMMON.hyphen}>{COMMON.hyphen}</option>
    <option value={COMMON.veryLow}>{COMMON.veryLow}</option>
    <option value={COMMON.low}>{COMMON.low}</option>
    <option value={COMMON.moderate}>{COMMON.moderate}</option>
    <option value={COMMON.high}>{COMMON.high}</option>
    <option value={COMMON.veryHigh}>{COMMON.veryHigh}</option>
  </Select>
);

export default SelectCiaLevelColumnFilter;
